import { render, staticRenderFns } from "./CheckBold.vue?vue&type=template&id=5603f41f"
import script from "./CheckBold.vue?vue&type=script&lang=js"
export * from "./CheckBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports